document.addEventListener('DOMContentLoaded', function () {
    const itemsPerPage = parseInt(document.querySelector('[data-items-per-page]')?.dataset?.itemsPerPage || 12);
      //const itemsPerPage = 3;

    const checkboxes = document.querySelectorAll('.filter-checkbox');
    const allItems = Array.from(document.querySelectorAll('.literature-container'));

    const clearAllButton = document.getElementById('clear-all-filters');
    const clearGroupButtons = document.querySelectorAll('.btn-clear-group');

    const prevBtn = document.getElementById('prev-page');
    const nextBtn = document.getElementById('next-page');
    const paginationNumbers = document.getElementById('pagination-numbers');

    let filteredItems = allItems; 
    let currentPage = 1;
    let totalPages = 1;

    const totalLiteratureCount = allItems.length;
    const totalCountSpan = document.getElementById('literature-total-count');

    function updateLiteratureCount() {
      if (filteredItems.length === totalLiteratureCount) {
        totalCountSpan.textContent = `${totalLiteratureCount} items`;
      } else {
        totalCountSpan.textContent = `${filteredItems.length} of ${totalLiteratureCount} items`;
      }
    }

    function updateClearButtons() {
      const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
      clearAllButton.style.display = anyChecked ? 'block' : 'none';

      ['industry', 'category', 'supplier'].forEach(group => {
        const groupCheckboxes = document.querySelectorAll(`[data-filter-type="${group}"]`);
        const groupChecked = Array.from(groupCheckboxes).some(cb => cb.checked);
        const groupButton = document.querySelector(`.btn-clear-group[data-filter-group="${group}"]`);
        if (groupButton) {
          groupButton.style.display = groupChecked ? 'inline-block' : 'none';
        }
      });
    }

    function updateSelectedTags() {
      const selectedTagsContainer = document.getElementById('selected-tags');
      const selectedFiltersBox = document.getElementById('selected-filters');

      selectedTagsContainer.innerHTML = '';

      const selectedCheckboxes = Array.from(checkboxes).filter(cb => cb.checked);

      if (selectedCheckboxes.length === 0) {
        selectedFiltersBox.style.display = 'none';
        return;
      }

      selectedFiltersBox.style.display = 'flex';

      selectedCheckboxes.forEach(cb => {
        const tag = document.createElement('div');
        tag.className = 'selected-tag';
        tag.innerHTML = `
          ${cb.value}
          <button type="button" data-uncheck="${cb.dataset.filterType}|${cb.value}">×</button>
        `;
        selectedTagsContainer.appendChild(tag);
      });

      selectedTagsContainer.querySelectorAll('.selected-tag').forEach(tag => {
        tag.addEventListener('click', (e) => {
          if (e.target.tagName === 'BUTTON') return;
          const btn = tag.querySelector('button[data-uncheck]');
          if (btn) {
            const [type, val] = btn.getAttribute('data-uncheck').split('|');
            document.querySelectorAll(`input[data-filter-type="${type}"][value="${val}"]`).forEach(checkbox => {
              checkbox.checked = false;
            });
            filterItems();
          }
        });
      });

      selectedTagsContainer.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const [type, val] = btn.getAttribute('data-uncheck').split('|');
          document.querySelectorAll(`input[data-filter-type="${type}"][value="${val}"]`).forEach(checkbox => {
            checkbox.checked = false;
          });
          filterItems();
        });
      });
    }

    function filterItems() {
      const selectedIndustries = Array.from(document.querySelectorAll('[data-filter-type="industry"]:checked')).map(cb => cb.value.toLowerCase());
      const selectedCategories = Array.from(document.querySelectorAll('[data-filter-type="category"]:checked')).map(cb => cb.value.toLowerCase());
      const selectedSuppliers = Array.from(document.querySelectorAll('[data-filter-type="supplier"]:checked')).map(cb => cb.value.toLowerCase());
    
      if (
        selectedIndustries.length === 0 &&
        selectedCategories.length === 0 &&
        selectedSuppliers.length === 0
      ) {
        filteredItems = allItems;
      } else {
        filteredItems = allItems.filter(item => {
          const itemIndustries = item.dataset.industries.split(',').map(i => i.trim().toLowerCase());
          const itemCategories = item.dataset.category.split(',').map(c => c.trim().toLowerCase());
          const itemSupplier = item.dataset.supplier.toLowerCase();
    
          const industryMatch = selectedIndustries.some(val => itemIndustries.includes(val));
          const categoryMatch = selectedCategories.some(val => itemCategories.includes(val));
          const supplierMatch = selectedSuppliers.includes(itemSupplier);
    
          return industryMatch || categoryMatch || supplierMatch;
        });
      }
    
      currentPage = 1;
      totalPages = Math.ceil(filteredItems.length / itemsPerPage) || 1;
    
      renderPage();
      updateClearButtons();
      updateURLParams();
      updateSelectedTags();
      updateLiteratureCount();
    }


    function updateURLParams() {
      const params = new URLSearchParams();
    
      ['industry', 'category', 'supplier'].forEach(type => {
        const selected = Array.from(document.querySelectorAll(`[data-filter-type="${type}"]:checked`)).map(cb => cb.value);
        if (selected.length > 0) {
          params.set(type, selected.join(','));
        }
      });
    
      const queryString = params.toString();
      const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
    
      history.replaceState(null, '', newUrl);
    }


    function restoreFiltersFromURL() {
      const params = new URLSearchParams(window.location.search);

      ['industry', 'category', 'supplier'].forEach(type => {
        const values = params.get(type);
        if (values) {
          const valueArray = values.split(',');
          document.querySelectorAll(`[data-filter-type="${type}"]`).forEach(cb => {
            if (valueArray.includes(cb.value)) {
              cb.checked = true;
            }
          });
        }
      });
    }

    function renderPage() {
      allItems.forEach(item => item.style.display = 'none');

      const startIdx = (currentPage - 1) * itemsPerPage;
      const endIdx = startIdx + itemsPerPage;

      filteredItems.slice(startIdx, endIdx).forEach(item => {
        item.style.display = '';
      });

      renderPaginationControls();

      const paginationContainer = document.querySelector('.pagination-container');
      if (filteredItems.length > itemsPerPage) {
        paginationContainer.style.display = 'flex';
      } else {
        paginationContainer.style.display = 'none';
      }
    }

    function renderPaginationControls() {
      paginationNumbers.innerHTML = '';

      prevBtn.disabled = currentPage === 1;
      nextBtn.disabled = currentPage === totalPages;

      const maxPagesToShow = 5;
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

      if (endPage - startPage < maxPagesToShow - 1) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      function createPageBtn(page) {
        const btn = document.createElement('button');
        btn.textContent = page;
        btn.className = 'pagination-btn';
        if (page === currentPage) {
          btn.disabled = true;
          btn.style.fontWeight = 'bold';
        }
        btn.addEventListener('click', () => {
          currentPage = page;
          renderPage();
        });
        return btn;
      }

      if (startPage > 1) {
        paginationNumbers.appendChild(createPageBtn(1));
        if (startPage > 2) {
          const dots = document.createElement('span');
          dots.textContent = ' ... ';
          paginationNumbers.appendChild(dots);
        }
      }

      for (let p = startPage; p <= endPage; p++) {
        paginationNumbers.appendChild(createPageBtn(p));
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          const dots = document.createElement('span');
          dots.textContent = ' ... ';
          paginationNumbers.appendChild(dots);
        }
        paginationNumbers.appendChild(createPageBtn(totalPages));
      }
    }

    prevBtn.addEventListener('click', () => {
      if (currentPage > 1) {
        currentPage--;
        renderPage();
      }
    });

    nextBtn.addEventListener('click', () => {
      if (currentPage < totalPages) {
        currentPage++;
        renderPage();
      }
    });

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', filterItems);
    });

    clearAllButton.addEventListener('click', () => {
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      filterItems();
    });

    clearGroupButtons.forEach(button => {
      button.addEventListener('click', () => {
        const filterGroup = button.getAttribute('data-filter-group');
        const groupCheckboxes = document.querySelectorAll(`[data-filter-type="${filterGroup}"]`);
        groupCheckboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
        filterItems();
      });
    });
    
    restoreFiltersFromURL();
    filterItems();
    updateLiteratureCount();
});
document.addEventListener("DOMContentLoaded", function() {
  var showFilterBtn = document.getElementById("showfiltermobile");
  var mobileFilterDiv = document.getElementById("mobilefilter");
  var closeFilterBtn = document.getElementById("closefilter");
  var body = document.body;

  showFilterBtn.addEventListener("click", function() {
    mobileFilterDiv.classList.add("active");
    body.classList.add("overflow-hidden-mobile");
  });

  closeFilterBtn.addEventListener("click", function() {
    mobileFilterDiv.classList.remove("active");
    body.classList.remove("overflow-hidden-mobile");
  });
});